import { RELOAD_AT } from '../config/board'

// "Play via URL" loads the page once at power-on and then leaves it running for
// weeks. One reload a night, inside the TV's off-hours, bounds any slow leak and
// picks up a deploy without anyone driving to the shop. Re-armed after the reload
// because the fresh page calls this again at boot (build-guide §7).
export function nightlyReload(reloadAt: string = RELOAD_AT): void {
  const parts = reloadAt.split(':')
  const next = new Date()
  next.setHours(Number(parts[0]), Number(parts[1]), 0, 0)
  if (next.getTime() <= Date.now()) next.setDate(next.getDate() + 1)
  window.setTimeout(() => window.location.reload(), next.getTime() - Date.now())
}
